import type { SxProps, Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

import type { DeliveryMode } from '../types/domain.types';

export { PROSE_MAX, proseSx } from '../../../core-components/theme/components/Screen';

const flowColumns = (min: number): Record<string, string> => ({
  xs: 'minmax(0, 1fr)',
  md: `repeat(auto-fit, minmax(min(100%, ${min}px), 1fr))`,
});

export const CARD_MIN_TRACK = 400;
export const FORM_CARD_MAX = 560;
export const TIME_FIELD_MAX = 180;
export const DURATION_FIELD_MAX = 220;
export const SEVERITY_LABEL_TRACK = '12rem';
export const ROUTING_ROLE_TRACK = '7rem';
export const ROUTING_SEVERITY_COLUMN = '10rem';
export const ROUTING_TOLD_NOW_COLUMN = '55%';

export const formCardSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  maxWidth: FORM_CARD_MAX,
};

export const cardListSx: SxProps<Theme> = {
  listStyle: 'none',
  m: 0,
  p: 0,
  display: 'grid',
  gap: 2,
  gridTemplateColumns: flowColumns(CARD_MIN_TRACK),
};

export const CONTAINER_SPLIT = '36rem';
export const SEVERITY_CHOICES_MAX = '36rem';

export const severityRowGridSx: SystemStyleObject<Theme> = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr)',
  alignItems: 'start',
  columnGap: 4,
  rowGap: 2,
  [`@container (min-width: ${CONTAINER_SPLIT})`]: {
    gridTemplateColumns: `minmax(0, ${SEVERITY_LABEL_TRACK}) minmax(0, ${SEVERITY_CHOICES_MAX})`,
  },
};

export const MODE_COLUMN: Readonly<Record<DeliveryMode, number>> = { NOW: 1, DIGEST: 2, OFF: 3 };

export const TIME_FIELD_MIN = '7.5rem';

export const timePairSx: SystemStyleObject<Theme> = {
  display: 'grid',
  gridTemplateColumns: `repeat(auto-fit, minmax(min(100%, ${TIME_FIELD_MIN}), 1fr))`,
  gap: 3,
  maxInlineSize: (theme: Theme) => `calc(2 * ${TIME_FIELD_MAX}px + ${theme.spacing(3)})`,
};

export const GROUP_GAP = 6;

export const quietBannerSlotSx: SxProps<Theme> = { marginBlockEnd: GROUP_GAP };
